import * as React from 'react';
import { useLatestRef } from './useLatestRef';

export function useMeasure() {
  const measurementRef = React.createRef<HTMLDivElement>();
  const [measurements, setMeasurements] = React.useState<DOMRect | null>(null);
  const setMeasurementsRef = useLatestRef(setMeasurements);

  const measureRef = useLatestRef(() => {
    const element = measurementRef.current;
    if (element) {
      setMeasurementsRef.current(element.getBoundingClientRect());
    }
  });

  React.useEffect(() => {
    measureRef.current();
  }, []);

  return {
    measurementRef,
    measurements,
    measureRef,
  };
}
